import {
  createContext, ReactNode, useCallback, useMemo,
} from 'react';
import api from '../services/api';

export interface HTMLExportContextValue {
  postExportHTML: (html:Blob, pageId?: string) => void
}

export const HTMLExportContext = createContext<HTMLExportContextValue>({
  postExportHTML: (html:Blob) => html,
});

const HTMLExportContextProvider = (props:{ children:ReactNode }) => {
  const { children } = props;

  const postExportHTML = useCallback(async (html: Blob, pageId?: string) => {
    const formData = new FormData();
    formData.append('file', html, 'export.html');
    if (pageId != null) {
      formData.append('page_id', pageId);
    }

    const res = await api.post('/v1/htmlfiles', formData, {
      headers: {
        'content-type': 'multipart/form-data',
      },
    });

    // サーバー側に保存したstatic htmlファイルを開きます
    window.open(`${process.env.REACT_APP_API_URL}${res.data}`);
  }, []);

  const value:HTMLExportContextValue = useMemo(() => ({
    postExportHTML,
  }), [postExportHTML]);

  return <HTMLExportContext.Provider value={value}>{children}</HTMLExportContext.Provider>;
};

export default HTMLExportContextProvider;
